import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CustomFileInput,
  CustomInput,
  Divider,
  FormFieldSet,
  HeaderCard,
  InfoTimeCardAdv,
  InvoicesHeader,
  InvoiceSidebar,
  LogoLoader,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
  showToast,
  Tag,
  ToolTip,
  useFormHandler,
  InfoCardNewAdv,
} from "../../../../components";
import {
  CreateInvoiceByOptions,
  InvoiceFrequencyOptions,
  netTermsOptions,
} from "../../../../assets/data/projectData";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { useDispatch } from "react-redux";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import FromToDateModal from "./Modal/FromToDateModal";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import common from "../../../../utils/common";
import { dateFormator } from "../../../../utils";
import { addInvoicesStart } from "../../../../redux/slices/invoices/invoicesSlice";
import { fetchLatestUiid } from "../../../../redux/slices/employee/employeeApi";
import ResendModal from "../Modals/ResendModal";
import { fetchPlacements } from "../../../../redux/slices/placements/placementsApi";
import dayjs from "dayjs";
import { exactUTCDate } from "../../../../utils/dateFormator";
import ProceedInvoice from "./Modal/ProceedInvoice";
import { sendEmail } from "../../../../utils/wf/email";
import { formatCurrency } from "../../../../utils/stringUtils";
import { version } from "react-dom/server";
const PlacementInvoives = ({ setViewApprovals, onBack }) => {
  const {
    splitByCase,
    mapDailyEntriesToRanges,
    calculateDiscountedTotal,
    mergeEntries,
    groupDatesByUiid,
    validateFormFields,
    validateDiscounts,
    formatDiscountDisplay,
    calculateTotalDiscountInvoice,
    generateInvoiceNumber,
    formatToMMDDYYYY,
  } = common;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [moreActionModal, setMoreActionModal] = useState(false);
  const [showfromToDate, setShowfromToDate] = useState(false);
  const [successRes, setSuccessRes] = useState(null);
  const navigate = useNavigate();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const org = loginUserData?.organizationId;
  const addr = org?.address || {};
  const contactEmail = org?.contactInformation?.[0]?.email?.primary;
  const formattedAddress = [
    org?.name,
    addr.address1,
    addr.address2,
    addr.city,
    addr.state,
    addr.country,
    addr.zipCode,
    contactEmail,
    org?.website
  ]
    .filter(Boolean)
    .join("\n");
  const defaultValues = {
    createInvoiceBy: "",
    client: "",
    invoiceFrequency: "",
    fromToDate: "",
    intervals: "",
    employees: "",
    billingAddress: " ",
    fromAddress: formattedAddress,
    netTerms: "",
    invoiceDate: new Date(),
    shippedDate: new Date(),
    dueDate: "",
    location: "",
    class: "",
    invoiceNumber: "",
    pONumber: "",
    includePOAttachment: [],
    contactEmail: [],
    ccEmail: [],
    bccEmail: [],
    consultantName: "",
    discounts: [
      {
        id: uuidv4(),
        ss: "",
        select: 1,
        activity: "",
        type: 1,
        discount: "",
        quantity: 0,
        amount: 0,
        rate: 0,
      },
    ],
    notes: "",
    statementMemo: "",
    includeNotesInInvoice: [],
    statementMemoFromTo: "",
    invoiceCetegoty: "",
    attachment: [],
    payableTo: "",
    additionalInfo: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValues, {
      client: { type: "select", required: true },
      employees: { type: "select", required: true },
    });
  const [tableData, setTableData] = useState([]);
  //
  const [placementsUiid, setPlacementsUiid] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [allEmployeeList, setAllEmployeeList] = useState([]);
  // new thing
  const [allClientsWithPlacementsList, setAllClientsWithPlacementsList] =
    useState([]);
  const [selectedClientWithPlacements, setSelectedClientWithPlacements] =
    useState({});

  const [allEmployeesWithPlacementsList, setAllEmployeeWIthPlacementsList] =
    useState([]);
  const [selectEmployeePlacement, setSelectEmployeePlacement] = useState({});
  const [allPreviousRanges, setAllPreviousRanges] = useState([]);
  console.log({
    allPreviousRanges,
  });
  const [selectClientOptions, setSelectClientOptions] = useState([]);
  // / timesheetData
  const [selectTimeSheetData, setSelectTimeSheetData] = useState([]);
  const [selectTimeSheetOriganalData, setSelectTimeSheetOriganalData] =
    useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [latestUiid, setLatestUiid] = useState();
  //
  const [billingInvoiceAddress, setBillingInvoiceAdress] = useState({});
  const [isMailSendModal, setISMailSendModal] = useState(false);
  const [createdInvoiceId, setCreatedInvoiceId] = useState(null);
  useEffect(() => {
    if (formattedAddress && !formData.fromAddress) {
      setFormData((prev) => ({
        ...prev,
        fromAddress: formattedAddress,
      }));
    }
  }, [formattedAddress, formData.fromAddress]);

  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    const checkFile =
      field === "attachment"
        ? Array.isArray(value)
          ? value
          : [value] // always wrap single file in array
        : newValue;
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: checkFile || "" } : row,
      ),
    );
  };

  useEffect(() => {
    const fetchInvoicesForPlacement = async () => {
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.INVOICES.GET_ALL,
          params: {
            coll: "Invoice",
            ret: "timesheetRef",
            fil: JSON.stringify({
              jobId: {
                type: "NONE",
                value: selectEmployeePlacement?.placements?.[0]?.uiid,
              },
              // "version.isLatest":{
              //   type: 'NONE',
              //   value: true,
              // }
            }),
          },
        });
        let allTimesheetRefs = response?.data?.data || [];
        console.log({ allTimesheetRefs });
        const all_from_to =
          allTimesheetRefs
            ?.flatMap(
              (item) =>
                item.timesheetRef?.map((ref) => {
                  const dates = ref.dates;
                  if (!dates?.length) return null;
                  // return { from: dayjs(dates[0],"YYYYMMDD").toDate(), to: dayjs(dates[dates.length - 1],"YYYYMMDD").toDate() };
                  const from = dayjs.utc(dates[0].toString(), "YYYYMMDD").toDate();
                  const to = dayjs
                    .utc(dates[dates.length - 1].toString(), "YYYYMMDD")
                    .toDate();
                  return { from, to };
                }) || [],
            )
            ?.filter(Boolean) || [];

        setAllPreviousRanges(all_from_to);
      } catch (error) {
        console.error(error);
      }
    };
    fetchInvoicesForPlacement();
  }, [selectEmployeePlacement]);

  const handleAddRow = () => {
    // if (isEdit) {
    const newRow = {
      id: uuidv4(),
      ss: "",
      activity: "",
      quantity: 0,
      amount: 0,
      rate: 0,
      attachment: [],
      editing: true,
      editable: true,
      delete: true,
    };
    setTableData((prev) => [...prev, newRow]);
    // }
  };

  const handleRemoveRow = (rowId) => {
    setTableData((prev) => {
      const updatedRows = prev.filter((row) => row.id !== rowId);
      return updatedRows.length > 0 ? updatedRows : prev;
    });
  };
  const handleEditRow = (rowId) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, editing: !row.editing } : row,
      ),
    );
  };

  const columns = [
    {
      key: "ss",
      label: "Service Summary",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter Name"
              value={row.ss || ""}
              onChange={(value) => handleRowChange(row.id, "ss", value)}
            />
          ) : (
            <span>{row.ss}</span>
          )}
        </div>
      ),
    },
    {
      key: "activity",
      label: "Activity",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="text"
              placeholder="Enter Name"
              title=""
              size="xs"
              value={row?.activity || ""}
              onChange={(value) => handleRowChange(row.id, "activity", value)}
            />
          ) : (
            <span>{row?.activity}</span>
          )}
        </div>
      ),
    },
    {
      key: "quantity",
      label: "Quantity (Hrs/days)",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.quantity || ""}
              onChange={(value) => handleRowChange(row.id, "quantity", value)}
            />
          ) : (
            <span>{row.quantity}</span>
          )}
        </div>
      ),
    },
    {
      key: "rate",
      label: "Rate",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.rate || ""}
              onChange={(value) => handleRowChange(row.id, "rate", value)}
            />
          ) : (
            <span>{row.rate}</span>
          )}
        </div>
      ),
    },

    {
      key: "amount",
      label: "Amount",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.amount || ""}
              onChange={(value) => handleRowChange(row.id, "amount", value)}
            />
          ) : (
            <span>{row.amount}</span>
          )}
        </div>
      ),
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomFileInput
              type="file"
              placeholder="choose file"
              title=""
              size="xs"
              value={row?.attachment || []}
              // onChange={(value) => handleRowChange(row.id, "attachment", value)}
              onChange={(file) => handleRowChange(row.id, "attachment", file)}
              key={row.id}
            />
          ) : (
            <span>{row.attachment?.[0]?.name || ""}</span>
          )}
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row min-w-max">
          {row.editable === true && (
            <Button
              type="icon"
              icon={row.editing ? "save" : "edit_square"}
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleEditRow(row.id)}
            />
          )}
          {row.delete === true && (
            <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleRemoveRow(row.id)}
            />
          )}
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={() => setMoreActionModal(!moreActionModal)}
          />
        </div>
      ),
    },
  ];

  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: formData?.discounts?.[0]?.type,
        value: "",
      },
    ]);
  };

  const handleRemoveDiscount = (id) => {
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id),
      );
    }
  };

  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };
  const handleDiscountTypeChange = (field, value) => {
    const formDiscount = formData?.discounts || [];
    const updatedDiscounts = formDiscount.map((data) => ({
      ...data,
      [field]: value, // Update the specific field for all discounts
    }));
    setFormData({
      ...formData,
      discounts: updatedDiscounts,
    });
  };

  const lastPayment =
    selectEmployeePlacement?.placements?.[0]?.payments?.at(-1);
  const billRate = lastPayment?.billRate?.rate;
  const tableAmountTotal = tableData.reduce(
    (sum, entry) => sum + Number(entry.amount || 0),
    0,
  );
  const totalSt = selectedValues.reduce((total, item) => {
    const entryTotal = item.dailyEntries?.reduce(
      (sum, entry) => sum + (entry.st || 0),
      0,
    );
    return total + entryTotal;
  }, 0);
  const totalDue =
    selectedValues.length > 0 &&
    typeof totalSt === "number" &&
    typeof billRate === "number"
      ? Number((totalSt * billRate).toFixed(2))
      : 0;

  const frequencyNumber =
    selectEmployeePlacement?.placements?.[0]?.invoices?.frequency;

  const handleFormAction = async (status) => {
    try {
      setLoading(true);
      const timesheetRef = await groupDatesByUiid(selectedValues);
      // if (timesheetRef.length === 0) {
      //   showToast("TimeSheet is required", "error", 1000);
      //   return;
      // }
      if (calculateDiscountedTotal(tableAmountTotal, formData?.discounts) === 0) {
        showToast("Invoice Amount cannot be zero", "error", 1000);
        return;
      }
      // Validate discounts before proceeding
      const discountErrors = validateDiscounts(formData?.discounts);
      if (discountErrors.length > 0) {
        showToast(discountErrors.join("\n"), "error", 3000);
        return;
      }
      // Filter discounts to only keep records with all required fields valid
      const filteredDiscounts = Array.isArray(formData?.discounts)
        ? formData.discounts.filter(
            (d) =>
              d &&
              typeof d.name === "string" &&
              d.name.trim() !== "" &&
              typeof d.comment === "string" &&
              d.comment.trim() !== "",
            // &&          typeof d.value === "number" &&
            //   !isNaN(d.value)
          )
        : [];

      // ✅ Construct invoice object
      const createInvoice = {
        clientId: selectEmployeePlacement?.clientId,
        invoiceCreatedBy: formData?.createInvoiceBy, // corrected key
        invoiceNum: formData?.invoiceNumber,
        poNum: formData?.pONumber,
        type: 1,
        frequency: formData?.intervals,
        frequencyPeriod: {
          from: formData?.fromToDate?.from,
          till: formData?.fromToDate?.to,
        },
        status: status,
        inclPOEmail: !!formData?.includePOAttachment?.[0],
        employeeId: selectEmployeePlacement?.uiid,
        jobId: selectEmployeePlacement?.placements?.[0]?.uiid,
        timesheetRef: timesheetRef,
        address: {
          billing: billingInvoiceAddress,
          // from: {
          //   address1: "TekTree LLC",
          //   city: "Drummond Plaza Newark",
          //   state: "DE",
          //   zipCode: 19711,
          //   country: "USA",
          // },
          from: {
            address1: addr?.address1 || "",
            address2: addr?.address2 || "",
            city: addr?.city || "",
            state: addr?.state || "",
            zipCode: addr?.zipCode || "",
            country: addr?.country || "",
            email: contactEmail || "",
            website:org?.website || "",
          },
        },
        netTerms: formData?.netTerms?.value ?? formData?.netTerms,
        invoiceDate: formData?.invoiceDate,
        shippedDate: formData?.shippedDate,
        dueDate: formData?.dueDate,
        amounts: {
          invoiced: calculateDiscountedTotal(
            tableAmountTotal,
            formData?.discounts,
          ),
          due: calculateDiscountedTotal(tableAmountTotal, formData?.discounts),
          // due, received can be added here
        },
        recipients: {
          to: formData?.contactEmail,
          cc: formData?.ccEmail,
          bcc: formData?.bccEmail,
        },
        serviceSummary: tableData,
        finalBill: {
          subTotal: tableAmountTotal,
          discounts: filteredDiscounts,
        },
        notes: formData?.notes,
        inclNotesPdf: !!formData?.includeNotesInInvoice?.[0],
        memo: formData?.statementMemo,
        memoPeriod: {
          from: formData?.statementMemoFromTo?.from,
          to: formData?.statementMemoFromTo?.to,
        },
        consultantName: formData?.consultantName,
        additionalInfo: formData?.additionalInfo,
        addedBy: loginUserUiid,
        // syncToQb: true,
        ...(selectEmployeePlacement?.placements?.[0]?.invoices?.isFunded && {
          funding: {
            status: 1,
            on: new Date(),
          },
        }),
      };
      // ✅ Clean data
      const submissionData = filterEmptyValues(createInvoice);
      // ✅ Filter attachments
      const cleanAttachments = Array.isArray(tableData)
        ? tableData.filter(
            (att) => Array.isArray(att.attachment) && att.attachment.length > 0,
          )
        : [];
      const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
        doc.attachment.map((file) => {
          file.id = doc.id; // add or overwrite id property
          return file; // return updated file object
        }),
      );
      // return;
      // ✅ Dispatch based on whether there are attachments
      if (cleanAttachmentsFiles.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            entity: "invoices",
            uiid: latestUiid,
            category: "ServiceSummaryDocuments",
            coll: "Invoice",

            doc: cleanAttachmentsFiles,
            onSuccess: (fileData) => {
              const updatedSubmissionData = {
                ...submissionData,
                serviceSummary: submissionData.serviceSummary?.map((data) => {
                  const matchedFile = fileData.find(
                    (f) => f?.fileRefId === data.id && f.key,
                  );
                  return {
                    ...data,
                    attachments: matchedFile ? [matchedFile.key] : [],
                  };
                }),
              };
              dispatch(
                addInvoicesStart({
                  coll: "Invoice",
                  postActions: ["AddToTimesheet"],
                  payload: updatedSubmissionData,
                  // onSuccess: (action) => {
                  //   // handle success here
                  //   if (status === 1) {
                  //     setIsProceedInvoiceOpen(false);
                  //     navigate(-1);
                  //   }
                  //   if (status === 2) {
                  //     setISMailSendModal(true);
                  //   }
                  // },
                  onSuccess: (response) => {
                    setLoading(false);
                    const newId = response?.data?.data?.id;
                    setCreatedInvoiceId(newId);
                    // handle success here
                    if (status === 1) {
                      setIsProceedInvoiceOpen(false);
                      navigate("/invoices");
                    }
                    if (status === 2) {
                      setISMailSendModal(true);
                    }
                  },
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addInvoicesStart({
            coll: "Invoice",
            postActions: ["AddToTimesheet"],
            payload: submissionData,
            // onSuccess: (action) => {
            //   if (status === 1) {
            //     setIsProceedInvoiceOpen(false);
            //     navigate(-1);
            //   }
            //   if (status === 2) {
            //     setIsProceedInvoiceOpen(false);
            //     // if to open email modal
            //     setISMailSendModal(true);
            //   }
            // },
            onSuccess: (response) => {
              setLoading(false);
              const newId =  response?.data?.data?.id ;
              setCreatedInvoiceId(newId);
              if (status === 1) {
                setIsProceedInvoiceOpen(false);
                navigate("/invoices");
              }
              if (status === 2) {
                setIsProceedInvoiceOpen(false);
                // if to open email modal
                setISMailSendModal(true);
              }
            },
          }),
        );
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    } finally {
      // setLoading(false);
    }
  };
  const handleSave = () => {
    const isValid = validateFormFields(validateAllFields);
    if (!isValid) {
      return;
    }
    handleFormAction(1); // Call the handleFormAction with actionType 1 for Save
  };

  const handleSubmit = async () => {
    try {
      const isValid = validateFormFields(validateAllFields);
      if (!isValid) {
        return;
      }
      handleFormAction(2);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSendMail = async (mailDetails) => {
    try {
      const timesheetRef = groupDatesByUiid(selectedValues)
      setIsMailLoading(true);
      if (!mailDetails?.emails?.selectedUsers?.length) {
        showToast("Please select at least one recipient", "error", 5000);
        setIsMailLoading(false);
        return;
      }
      const actions = [
        ...(mailDetails?.attachments?.includes(1) ? [{
          type: "INVOICE_PDF",
          params: {
           invoiceId: successRes?.invoiceId || null,
          },
        }] : []),
        ...(mailDetails?.attachments?.includes(2) ? [{
          type: "TS_FILES_PDF",
          params: {
            timesheetIds: timesheetRef?.map((ref) => ref.id) || [],
          }
        }] : []),
      ]
      
      const res = await sendEmail({
        to: mailDetails?.emails?.selectedUsers?.map((data) => data.email) || [],
        cc: mailDetails?.emails.ccUsers?.map((data) => data.email) || [],
        bcc: mailDetails?.emails.bccUsers?.map((data) => data.email) || [],
        subject: mailDetails.subject,
        html: mailDetails.body,
      }, actions);
      if(res?.success){
        showToast("Email Sent", "success", 5000);
        setISMailSendModal(!isMailSendModal);
      }
    } catch (error) {
      showToast("Failed to send email", "error", 5000);
      console.error("Error sending email:", error);
    } finally {
      setIsMailLoading(false);
      //compulasory to close mail modal and navigate after mail sent
      setISMailSendModal(false);
      navigate("/invoices");
    }
  };
  const showFeilds = () => {
    if (
      formData.createInvoiceBy === 2
      // formData.createInvoiceBy === "Manual"
    ) {
      return !!formData.client;
    } else {
      return !!formData.employees;
    }
  };

  const handleSelectClientNVender = (options, data = [], value) => {
    if (!Array.isArray(data) || !value) {
      setAllClientsWithPlacementsList([]);
      setSelectedClientWithPlacements({});
      return;
    }
    const allClientsData = data.find((item) => item?.uiid === value);
    if (allClientsData && Array.isArray(allClientsData.placements)) {
      setPlacementsUiid(allClientsData.placements);
      setAllClientsWithPlacementsList(options);
      setSelectedClientWithPlacements(allClientsData);
    } else {
      setAllClientsWithPlacementsList([]);
      setSelectedClientWithPlacements({});
    }
  };

  const handleSelectEmployeeNPlacement = async (
    options = [],
    data = [],
    value,
    option,
    type,
  ) => {
    setEmployeeOptions(options);
    setAllEmployeeList(data);

    const selectedEmployee = data.find(
      (item) => String(item?.uiid) === String(option?.uiid),
    );
    if (!selectedEmployee) {
      setSelectEmployeePlacement(null);
      return;
    }
    const matchingPlacement = selectedClientWithPlacements?.placements?.find(
      (placement) =>
        String(placement?.uiid) === String(option?.placementId) &&
        String(placement?.clientId?.uiid) ===
          String(selectedClientWithPlacements?.uiid) &&
        String(placement?.employeeId) === String(option?.uiid),
    );
    let placementDetails = {};
    if (matchingPlacement) {
      try {
        const response = await fetchPlacements({
          fil: {
            uiid: { type: "NONE", value: matchingPlacement.uiid },
          },
          ret: "apexDates payments invoices clientPlacement.placement",
        });

        if (response.success) {
          placementDetails = response?.data?.data || {};
        } else {
          console.error("Fetch failed:", response.message || response.error);
        }
      } catch (error) {
        console.error("Error fetching placement:", error);
      }
    }
    const filterData = {
      ...selectedEmployee,
      businessName: selectedClientWithPlacements?.businessName,
      clientId: selectedClientWithPlacements?.uiid,
      placements: matchingPlacement
        ? [{ ...matchingPlacement, ...placementDetails }]
        : [],
    };
    setSelectEmployeePlacement(filterData);
  };

  const handleSelectEmployeeNClientNPlacement = async (
    options = [],
    data = [],
    value,
    option,
  ) => {
    setAllEmployeeWIthPlacementsList(data);
    // Find selected employee
    const selectedEmployee = data.find(
      (item) => String(item?.uiid) === String(option?.uiid),
    );
    if (!selectedEmployee) {
      setSelectEmployeePlacement(null);
      return;
    }
    // Find matching placement
    const matchingPlacement = selectedEmployee?.placements?.find(
      (placement) =>
        String(placement?.uiid) === String(option?.placementId) &&
        String(placement?.clientId?.uiid) === String(option?.clientId) &&
        String(placement?.employeeId) === String(selectedEmployee?.uiid),
    );
    let placementDetails = {};
    if (matchingPlacement) {
      try {
        const response = await fetchPlacements({
          fil: {
            uiid: { type: "NONE", value: matchingPlacement.uiid },
          },
          ret: "apexDates payments invoices clientPlacement.placement", // fix: 'ref' → 'ret' if you intend to return fields
        });

        if (response.success) {
          // Adjust depending on API response structure
          placementDetails = response?.data?.data || response?.data || {};
        } else {
          console.error("Fetch failed:", response.message || response.error);
        }
      } catch (error) {
        console.error("Error fetching placement:", error);
      }
    }
    const filterData = {
      ...selectedEmployee,
      businessName: option?.businessName,
      clientId: option?.clientId,
      placements: matchingPlacement
        ? [{ ...matchingPlacement, ...placementDetails }]
        : [],
    };
    setSelectEmployeePlacement(filterData);
    // Debug logs
    handleChange("client", {
      label: `${option?.businessName}-${option?.placementId}`,
      value: option?.clientId,
    });
  };
  useEffect(() => {
    const invoices = selectEmployeePlacement?.placements?.[0]?.invoices || {};
    const payments =
      selectEmployeePlacement?.placements?.[0]?.payments?.at(-1) || {};

    // Check if invoices exist and if billNNotify exists within invoices
    if (invoices) {
      // Ensure that billNNotify exists before accessing billingAddress
      // if (invoices?.billNNotify) {
      //   handleChange("billingAddress", invoices?.billNNotify?.billingAddress);
      // }
      if (invoices?.cc) {
        const ccEmails = invoices?.cc || [];
        handleChange("ccEmail", ccEmails);
      }
      if (invoices?.additionalInfo) {
        const additionalInfo = invoices?.additionalInfo || "";
        handleChange("additionalInfo", additionalInfo);
      }
      handleChange(
        "consultantName",
        `${selectEmployeePlacement?.firstName} ${selectEmployeePlacement?.lastName}`,
      );
      const serviceSummary = {
        id: uuidv4(),
        ss: [selectEmployeePlacement?.firstName, selectEmployeePlacement?.lastName].filter(Boolean).join(" "),
        // active:
        rate: payments?.payRate?.payRatePerHour,
        delete: false,
        editable: true,
      };
      setTableData([serviceSummary]);
    }
    if (payments) {
      handleChange("pONumber", payments?.poNum);
    }
  }, [selectEmployeePlacement, formData?.netTerms]);

  const handleCallInvoiceApi = async (val) => {
    handleChange("fromToDate", val);
    setSelectTimeSheetData([]);
    setSelectTimeSheetOriganalData([]);
    setShowfromToDate(false);
    const placements = selectEmployeePlacement?.placements || [];
    const invoices = placements[0]?.invoices || {};
    const { frequency, frequencyStartDay } = invoices;
    const placementId = placements[0]?.uiid;
    const apexDates = placements[0]?.apexDates;
    const checkCycle = frequency ? (frequency === 5 ? true : false) : false;

    // Early exit if required data is missing
    if (!frequency || !placementId) {
      console.warn("Missing required fields for API call.");
      // showToast("Please make sure the invoice frequency is filled in the placements.","error")
      return;
    }
    let filters = {
      // periodCycle: { type: "NONE", value: periodCycle },
      placementId: { type: "NONE", value: placementId },
      status: { type: "NONE", value: 3 },
      dailyEntries: { type: "ELEM_EXISTS", value: ["invoiceId", false] },
    };
    if ((!val?.from || !val?.to) && checkCycle) {
      console.warn("Missing required fields for API call.");

      return;
    }
    if (val?.form && val?.to) {
      filters = {
        ...filters,
        "period.from": { type: "GTE", value: val.from },
        "period.to": { type: "LTE", value: val.to },
      };
    }
    try {
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.TIMESHEETS.GET_ALL,
        params: {
          coll: "Timesheet",
          fil: JSON.stringify(filters),
          cache: false,
          ret: "period dailyEntries uiid  status",
          sort: JSON.stringify({ uiid: -1 }),
        },
      });
      const timeSheetData = response?.data?.data || [];
      console.log({ timeSheetData });
      if (!timeSheetData.length) throw new Error("Timesheet Not Found");

      const filteredEntries = timeSheetData
        .map((item) => {
          const filteredEntries = Array.isArray(item.dailyEntries)
            ? item.dailyEntries.filter((entry) => !entry?.invoiceId)
            : [];
          return {
            ...item,
            dailyEntries: filteredEntries,
          };
        })
        // Optional: only include items that have at least one entry remaining
        .filter((item) => item.dailyEntries.length > 0);

      const mergeEntriesData = mergeEntries(filteredEntries);
      setSelectTimeSheetOriganalData(timeSheetData);
      const dateRange = await splitByCase(
        mergeEntriesData,
        frequency,
        frequencyStartDay,
        val,
        apexDates,
      );
      const placements = selectEmployeePlacement?.placements || [];
      const companyName = selectEmployeePlacement?.businessName;
      const userFirstName = selectEmployeePlacement?.firstName;
      const jobTitle = placements?.[0]?.jobTitle || "";
      const jobPlacement = placements?.[0]?.clientPlacement?.placement || "";

      const combinedData = await mapDailyEntriesToRanges(
        mergeEntriesData || [],
        dateRange || [],
        frequency,
        companyName,
        userFirstName,
        jobTitle,
        jobPlacement,
      );
      const filteredCombinedData = combinedData
        .map((item) => {
          const validRanges = Array.isArray(item.ranges)
            ? item.ranges.filter(
                (r) =>
                  Array.isArray(r.dailyEntries) && r.dailyEntries.length > 0,
              )
            : [];

          if (validRanges.length > 0) {
            return { ...item, ranges: validRanges };
          }
          return null; // Exclude this item later if no valid ranges
        })
        .filter(Boolean); // Remove null items
      setSelectTimeSheetData(filteredCombinedData);
    } catch (error) {
      console.log({ errorM: error?.message });
      showToast(
        error?.message ? `${error?.message}` : "Timesheet issue",
        "error",
      );
      console.error("Error fetching invoice data:", error);
    }
  };
  useEffect(() => {
    const fetchEntityDetails = async () => {
      try {
        const placements = selectEmployeePlacement?.placements || [];
        const clientUiid = selectEmployeePlacement?.clientId;
        // Skip if either is falsy (null, undefined, empty string, etc.)
        if (!clientUiid) return;
        const url = ENDPOINTS.CLIENTS.GET_BY_UIID;
        if (!url) return;
        const response = await axiosRequest({
          method: "GET",
          url,
          params: {
            coll: "Client",
            fil: JSON.stringify({ uiid: { type: "NONE", value: clientUiid } }),
            cache: false,
            ret: "generalInfo roleContacts businessName",
          },
        });
        const locations = response?.data?.data?.generalInfo?.locations || [];
        const roleContacts = response?.data?.data?.roleContacts || [];
        if (response?.success) {
          const netTerms =
            response?.data?.data?.generalInfo?.placementDetails?.recurring
              ?.netTerms;
          if (netTerms) {
            handleChange("netTerms", { label: netTerms, value: netTerms });
          }
          const defaultInvoiceLocation = locations.find(
            (loc) => loc.isDefaultInvoice === true,
          );
          if (defaultInvoiceLocation) {
            const formattedAddress = [
              response?.data?.data?.businessName,
              defaultInvoiceLocation.address1,
              defaultInvoiceLocation.address2,
              defaultInvoiceLocation.city,
              defaultInvoiceLocation.state,
              defaultInvoiceLocation.country,
              defaultInvoiceLocation.zipCode,
            ]
              .filter(Boolean)
              // .join(",");
              .join("\n");
            setBillingInvoiceAdress(defaultInvoiceLocation);
            handleChange("billingAddress", formattedAddress);
          }
          if (roleContacts.length > 0) {
            const filterEmails = roleContacts
              .filter((data) => data.email && data.email.length > 0)
              .flatMap((data) => data.email);
            handleChange("contactEmail", filterEmails);
          }
        }
      } catch (error) {
        console.error("Error fetching entity details:", error);
        // You could also optionally log to an error monitoring service here
      }
    };

    fetchEntityDetails();
  }, [formData.client, formData?.employees, selectEmployeePlacement]);
  useEffect(() => {
    if (formData.netTerms && formData.invoiceDate) {
      const number = String(
        formData?.netTerms?.value ?? formData?.netTerms ?? "0",
      ).match(/\d+/);
      const extractedNumber = number ? parseInt(number[0], 10) : null;
      if (extractedNumber !== null) {
        // Convert invoiceDate to Date object
        const invoiceDate = new Date(formData?.invoiceDate);
        // Add the extracted number of days to the invoiceDate
        invoiceDate.setDate(invoiceDate.getDate() + extractedNumber);
        // Format the dueDate (YYYY-MM-DD format)
        const dueDate = invoiceDate.toISOString().split("T")[0]; // "YYYY-MM-DD"
        // Update the dueDate
        handleChange("dueDate", dueDate);
      }
    }
  }, [formData.netTerms, formData.invoiceDate]);

  useEffect(() => {
    const handleInvoiceGeneration = async () => {
      const isCycleFive = frequencyNumber === 5;
      if (!isCycleFive) {
        if (formData?.client && formData?.employees) {
          await handleCallInvoiceApi();
        }
      }
      if (
        formData?.client &&
        formData?.employees &&
        formData?.createInvoiceBy &&
        selectEmployeePlacement
      ) {
        const newInvoiceNumber = await generateInvoiceNumber(latestUiid);
        handleChange("invoiceNumber", newInvoiceNumber);
      }
    };
    handleInvoiceGeneration();
  }, [
    formData?.client,
    formData?.employees,
    formData?.createInvoiceBy,
    selectEmployeePlacement,
    selectClientOptions,
  ]);

  // before 13/11/2025
  // const handleSelectTimeDate = (e) => {
  //   setSelectedValues(e);
  //   const timeData = e;
  //   const value = [];

  //   const payments =
  //     selectEmployeePlacement?.placements?.[0]?.payments?.at(-1) || {};
  //   timeData.forEach((data) => {
  //     const dailyEntries = data.dailyEntries || [];
  //     const totalHours = dailyEntries.reduce(
  //       (sum, entry) => sum + (entry.st || 0),
  //       0,
  //     );
  //     // const form = new Date(data.from).toLocaleDateString();
  //     // const to = new Date(data.to).toLocaleDateString();
  //     // const form = dayjs(data.from).format("MM/DD/YYYY");
  //     // const to = dayjs(data.to).format("MM/DD/YYYY");
  //     // const form = dateFormator(data.from);
  //     // const to = dateFormator(data.to);
  //     const form = exactUTCDate(data.from);
  //     const to = exactUTCDate(data.to);
  //     const amount = totalHours * (payments?.billRate?.rate || 0);
  //     const displayText = "INVOICE PERIOD FROM";
  //     value.push({
  //       id: uuidv4(),
  //       ss: selectEmployeePlacement?.firstName,
  //       rate: payments?.billRate?.rate || 0,
  //       activity: `${displayText} ${form} - ${to}`,
  //       fromDates: {
  //         from: data.from,
  //         to: data.to,
  //       },
  //       quantity: totalHours,
  //       amount: amount,
  //       editable: false,
  //       delete: true,
  //       tableSheetData: true,
  //     });
  //   });
  //   const group1 = tableData.filter(
  //     (row) => row.editable === false && row.delete === false,
  //   );
  //   const group2 = tableData.filter(
  //     (row) => row.editable === true && row.delete === true,
  //   );

  //   let updateData = [];

  //   if (value.length) {
  //     // Update group1 entries with values
  //     const updatedGroup1 = group1.map((data, index) => {
  //       const newValue = value[index] || value[0]; // fallback to value[0] if not enough
  //       handleChange("statementMemoFromTo", newValue.fromDates);
  //       const [startDate, endDate] = newValue.activity.split(" - ");
  //       const formattedRange = `${formatToMMDDYYYY(
  //         startDate.split("FROM ")[1],
  //       )} - ${formatToMMDDYYYY(endDate)}`;
  //       return {
  //         ...data,
  //         // activity: formattedRange,
  //         activity: newValue.activity,
  //         quantity: newValue.quantity,
  //         amount: newValue.amount,
  //         rate: newValue.rate,
  //       };
  //     });
  //     // Remaining values that were not used for group1
  //     const remainingValues = value.slice(group1.length);
  //     updateData = [...updatedGroup1, ...group2, ...remainingValues];
  //   } else {
  //     const resetGroup1 = group1.map((data) => ({
  //       ...data,
  //       rate: 0,
  //       activity: "",
  //       quantity: 0,
  //       amount: 0,
  //     }));
  //     handleChange("statementMemoFromTo", "");
  //     updateData = [...resetGroup1, ...group2];
  //   }
  //   setSelectedValues(e);
  //   setTableData(updateData);
  // };

  // after 13/11/2025
  // const handleSelectTimeDate = (e) => {
  //   setSelectedValues(e);
  //   const timeData = e;
  //   console.log({timeData});
  //   const value = [];
  //   const payments =
  //     selectEmployeePlacement?.placements?.[0]?.payments?.at(-1) || {};

  //   // Get all payments sorted by effective date
  //   let allPaymentsWithBillRate =
  //     selectEmployeePlacement?.placements?.[0]?.payments
  //       ?.map((payment) => ({
  //         billRate: payment?.billRate?.rate || 0,
  //         effectiveDate: dayjs(exactUTCDate(payment?.payRate?.effectiveDate)),
  //       }))
  //       ?.sort((a, b) => a.effectiveDate.valueOf() - b.effectiveDate.valueOf());
  //   timeData.forEach((data) => {
  //     const dailyEntries = data.dailyEntries || [];
  //     // Group dailyEntries by applicable bill rate based on effectiveDate
  //     const groupedByRate = {};

  //     dailyEntries.forEach((entry) => {
  //       const entryDate = dayjs(`${entry.date}`, "YYYYMMDD").startOf("day");

  //       const applicablePayment = [...allPaymentsWithBillRate]
  //         .reverse()
  //         .find((p) => entryDate.isSameOrAfter(dayjs(p.effectiveDate)));

  //       const billRate =
  //         applicablePayment?.billRate || payments?.billRate?.rate || 0;

  //       if (!groupedByRate[billRate]) groupedByRate[billRate] = [];
  //       groupedByRate[billRate].push(entry);
  //     });

  //     // For each rate group, compute totals and push separate record
  //     Object.entries(groupedByRate).forEach(([rate, entries]) => {
  //       const totalHours = entries.reduce(
  //         (sum, entry) => sum + (entry.st || 0),
  //         0,
  //       );

  //       const firstDate = dayjs.utc(`${entries[0].date}`, "YYYYMMDD");
  //       const lastDate = dayjs.utc(
  //         `${entries[entries.length - 1].date}`,
  //         "YYYYMMDD",
  //       );

  //       // const form = firstDate.format("MM/DD/YYYY");
  //       // const to = lastDate.format("MM/DD/YYYY");
  //       const form = exactUTCDate(firstDate);
  //       const to = exactUTCDate(lastDate);

  //       const amount = totalHours * Number(rate);
  //       const displayText = "INVOICE PERIOD FROM";

  //       value.push({
  //         id: uuidv4(),
  //         ss: selectEmployeePlacement?.firstName,
  //         rate: Number(rate),
  //         activity: `${displayText} ${form} - ${to}`,
  //         fromDates: {
  //           from: firstDate.toISOString(),
  //           to: lastDate.toISOString(),
  //         },
  //         quantity: totalHours,
  //         amount: amount,
  //         editable: false,
  //         delete: true,
  //         tableSheetData: true,
  //       });
  //     });
  //   });

  //   // Handle table grouping and update logic
  //   const group1 = tableData.filter(
  //     (row) => row.editable === false && row.delete === false,
  //   );
  //   const group2 = tableData.filter(
  //     (row) => row.editable === true && row.delete === true,
  //   );

  //   let updateData = [];

  //   if (value.length) {
  //     const updatedGroup1 = group1.map((data, index) => {
  //       const newValue = value[index] || value[0];
  //       handleChange("statementMemoFromTo", newValue.fromDates);
  //       const [startDate, endDate] = newValue.activity.split(" - ");
  //       const formattedRange = `${formatToMMDDYYYY(
  //         startDate.split("FROM ")[1],
  //       )} - ${formatToMMDDYYYY(endDate)}`;
  //       return {
  //         ...data,
  //         activity: newValue.activity,
  //         quantity: newValue.quantity,
  //         amount: newValue.amount,
  //         rate: newValue.rate,
  //       };
  //     });
  //     const remainingValues = value.slice(group1.length);
  //     updateData = [...updatedGroup1, ...group2, ...remainingValues];
  //   } else {
  //     const resetGroup1 = group1.map((data) => ({
  //       ...data,
  //       rate: 0,
  //       activity: "",
  //       quantity: 0,
  //       amount: 0,
  //     }));
  //     handleChange("statementMemoFromTo", "");
  //     updateData = [...resetGroup1, ...group2];
  //   }

  //   setSelectedValues(e);
  //   setTableData(updateData);
  // };
  //
  //

  // //testing
  const handleSelectTimeDate = (e) => {
    setSelectedValues(e);
    const timeData = e;
    console.log({ timeData });

    const value = [];
    const payments =
      selectEmployeePlacement?.placements?.[0]?.payments?.at(-1) || {};

    // Get all payments sorted by effective date
    const allPaymentsWithBillRate =
      selectEmployeePlacement?.placements?.[0]?.payments
        ?.map((payment) => ({
          billRate: payment?.billRate?.rate || 0,
          effectiveDate: dayjs(exactUTCDate(payment?.payRate?.effectiveDate)),
        }))
        ?.sort(
          (a, b) => a.effectiveDate.valueOf() - b.effectiveDate.valueOf(),
        ) || [];

    timeData.forEach((data) => {
      const dailyEntries = data.dailyEntries || [];
      const groupedByRate = {};

      // Group daily entries by applicable bill rate
      dailyEntries.forEach((entry) => {
        const entryDate = dayjs(`${entry.date}`, "YYYYMMDD").startOf("day");
        const applicablePayment = [...allPaymentsWithBillRate]
          .reverse()
          .find((p) => entryDate.isSameOrAfter(dayjs(p.effectiveDate)));

        const billRate =
          applicablePayment?.billRate || payments?.billRate?.rate || 0;

        if (!groupedByRate[billRate]) groupedByRate[billRate] = [];
        groupedByRate[billRate].push(entry);
      });

      // Build value entries
      Object.entries(groupedByRate).forEach(([rate, entries], index, arr) => {
        const totalHours = entries.reduce(
          (sum, entry) => sum + (entry.st || 0),
          0,
        );

        let firstDate = dayjs
          .utc(`${entries[0].date}`, "YYYYMMDD")
          .toISOString();
        let lastDate = dayjs
          .utc(`${entries[entries.length - 1].date}`, "YYYYMMDD")
          .toISOString();
        // Adjust start/end dates based on split count
        if (arr.length === 1) {
          // No split → use full timesheet range
          console.log("No split");
          if (data?.from) firstDate = data.from;
          if (data?.to) lastDate = data.to;
        } else {
          // Split case → adjust first and last groups
          if (index === 0 && data?.from) {
            console.log("First group");
            firstDate = data.from;
          }
          if (index === arr.length - 1 && data?.to) {
            console.log("Last group");
            lastDate = data.to;
          }
        }
        console.log({
          firstDate,
          lastDate,
          entry1: entries[0].date,
          entryto: entries[entries.length - 1].date,
        });
        const form = exactUTCDate(firstDate);
        const to = exactUTCDate(lastDate);
        // const form = firstDate.format("MM/DD/YYYY");
        // const to = lastDate.format("MM/DD/YYYY");
        const amount = totalHours * Number(rate);
        const displayText = "INVOICE PERIOD FROM";
        value.push({
          id: uuidv4(),
          ss: [selectEmployeePlacement?.firstName, selectEmployeePlacement?.lastName].filter(Boolean).join(" "),
          rate: Number(rate),
          activity: `${displayText} ${form} - ${to}`,
          fromDates: {
            from: firstDate,
            to: lastDate,
          },
          quantity: totalHours,
          amount,
          editable: false,
          delete: true,
          tableSheetData: true,
        });
      });
    });

    // Handle table grouping and update logic
    const group1 = tableData.filter(
      (row) => row.editable === false && row.delete === false,
    );
    const group2 = tableData.filter(
      (row) => row.editable === true && row.delete === true,
    );

    let updateData = [];

    if (value.length) {
      const updatedGroup1 = group1.map((data, index) => {
        const newValue = value[index] || value[0];
        handleChange("statementMemoFromTo", newValue.fromDates);
        const [startDate, endDate] = newValue.activity.split(" - ");
        const formattedRange = `${formatToMMDDYYYY(
          startDate.split("FROM ")[1],
        )} - ${formatToMMDDYYYY(endDate)}`;
        return {
          ...data,
          activity: newValue.activity,
          quantity: newValue.quantity,
          amount: newValue.amount,
          rate: newValue.rate,
        };
      });

      const remainingValues = value.slice(group1.length);
      updateData = [...updatedGroup1, ...group2, ...remainingValues];
    } else {
      const resetGroup1 = group1.map((data) => ({
        ...data,
        rate: 0,
        activity: "",
        quantity: 0,
        amount: 0,
      }));
      handleChange("statementMemoFromTo", "");
      updateData = [...resetGroup1, ...group2];
    }
    setTableData(updateData);
  };

  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("invoices");
        const count = response?.data?.data?.count;
        if (typeof count === "number") {
          setLatestUiid(count + 1);
        } else {
          setLatestUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        setLatestUiid(1);
      }
    };

    fetchLatestUiidData();
  }, []);

  //////////////
  const [isProceedInvoiceOpen, setIsProceedInvoiceOpen] = useState(false);
  //////////////

  return (
    <div className="flex-1 flex flex-col lg:flex-row gap-2 h-full overflow-hidden">
      <div
        className={`border-[1px] border-neutrals-50 rounded p-3 mt-2 overflow-auto ${formData.client &&
          formData.employees &&
          selectTimeSheetData.length > 0
          ? "w-full lg:w-[80%] "
          : "w-full"
          }`}
      >
        <PageHeader
          Section={
            <div className="flex gap-3 mt-2">
              <PageTitle title={"Create Invoice"} tag="p" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3 mt-2">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                // onClick={() => navigate(-1)}
                onClick={() => navigate("/invoices")}
              />
            </div>
          }
        />
        <div className="flex flex-col-reverse lg:flex-row mt-3 gap-1 xl:gap-3">
          <div
            className={`grid ${formData.client &&
              formData.employees &&
              selectTimeSheetData.length > 0
                ? "grid-cols-2 xl:grid-cols-3"
                : "grid-cols-2 xl:grid-cols-3"
            } gap-x-6 gap-y-4 mt-3 flex-1`}
          >
            <FormFieldSet
              type="select"
              title="Create Invoice By"
              placeholder="Select Create Invoice By"
              value={formData.createInvoiceBy}
              onChange={(value) => {
                handleChange("createInvoiceBy", value);
                handleChange("client", "");
                handleChange("employees", "");
                handleChange("invoiceFrequency", "");
                setFormData({
                  ...defaultValues,
                  createInvoiceBy: value,
                });
                setTableData([]);
                handleChange("fromToDate", "");
                handleChange("intervals", "");
                setSelectTimeSheetData([]);
                setSelectTimeSheetOriganalData([]);
                setSelectedValues([]);
                setAllClientsWithPlacementsList([]);
                setSelectedClientWithPlacements({});
              }}
              error={errors.createInvoiceBy}
              options={CreateInvoiceByOptions}
            />
            {/* Conditional field order */}
            {[1, 3].includes(formData.createInvoiceBy) ? (
              <>
                <FormFieldSet
                  type="clientsWithPlacements"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  onChange={(value) => {
                    handleChange("employees", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("client", value);
                    setTableData([]);
                    setSelectTimeSheetData([]);
                    setSelectTimeSheetOriganalData([]);
                    setSelectedValues([]);
                  }}
                  error={errors.client}
                  filters={{
                    useAggregate: true,
                    type: 1,
                  }}
                  showSearch
                  disabled={!formData.createInvoiceBy}
                  onSelectItem={(options, data, value) =>
                    handleSelectClientNVender(options, data, value)
                  }
                />
                {frequencyNumber === 5 && (
                  <FormFieldSet
                    type="select"
                    title="Invoice Frequency"
                    placeholder="Select Invoice Frequency"
                    value={formData.invoiceFrequency}
                    onChange={(value) => {
                      handleChange("invoiceFrequency", value);

                      if (value === "By Dates") {
                        handleChange("fromToDate", "");
                        setShowfromToDate(true);
                      } else if (value === "By System Intervals") {
                        handleChange("fromToDate", "");
                        handleChange("intervals", "");
                        setShowfromToDate(false);
                      }
                    }}
                    error={errors.invoiceFrequency}
                    options={InvoiceFrequencyOptions}
                    disabled={frequencyNumber !== 5}
                  />
                )}
                <FormFieldSet
                  type={
                    selectedClientWithPlacements ? "allEmployees" : "select"
                  }
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("employees", value);
                  }}
                  error={errors.employees}
                  disabled={!formData.createInvoiceBy}
                  filters={{
                    ret: "firstName middleName lastName email.primary uiid",
                    fil: {
                      uiid: {
                        type: "IN",
                        value: [
                          ...new Set(
                            (
                              selectedClientWithPlacements?.placements || []
                            ).map((p) => p.employeeId),
                          ),
                        ],
                      },
                    },
                    selectedClientWithPlacements:
                      selectedClientWithPlacements || {},
                  }}
                  onSelectItem={(options, data, value, option) =>
                    handleSelectEmployeeNPlacement(
                      options,
                      data,
                      value,
                      option,
                      "client",
                    )
                  }
                />
              </>
            ) : (
              <>
                {/* Employees First */}
                <FormFieldSet
                  type="employeeWithPlacement"
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("client", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("employees", value);
                    setTableData([]);
                    setSelectTimeSheetData([]);
                    setSelectTimeSheetOriganalData([]);
                    setSelectedValues([]);
                  }}
                  error={errors.employees}
                  filters={{
                    ret: "firstName middleName lastName email.primary uiid placements",
                    useAggregate: true,
                    type: 1,
                  }}
                  showSearch
                  disabled={!formData.createInvoiceBy}
                  onSelectItem={(options, data, value, option) => {
                    handleSelectEmployeeNClientNPlacement(
                      options,
                      data,
                      value,
                      option,
                    );
                  }}
                />
                {/* Invoice Frequency */}
                {frequencyNumber === 5 && (
                  <FormFieldSet
                    type="select"
                    title="Invoice Frequency"
                    placeholder="Select Invoice Frequency"
                    value={formData.invoiceFrequency}
                    // onChange={(value) => handleChange("invoiceFrequency", value)}
                    onChange={(value) => {
                      handleChange("invoiceFrequency", value);

                      if (value === "By Dates") {
                        handleChange("fromToDate", ""); // reset intervals
                        setShowfromToDate(true); // open modal
                      } else if (value === "By System Intervals") {
                        handleChange("fromToDate", "");
                        handleChange("intervals", ""); // reset dates
                        setShowfromToDate(false); // close modal
                      }
                    }}
                    error={errors.invoiceFrequency}
                    options={InvoiceFrequencyOptions}
                    // disabled={!formData.createInvoiceBy}
                    disabled={frequencyNumber !== 5}
                  />
                )}
                <FormFieldSet
                  type="select"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  uiid={1}
                  // onChange={(value) => handleSelectClientPlacement(value)}
                  error={errors.client}
                  // showButton
                  showSearch
                  options={[]}
                  disabled={!formData.createInvoiceBy}
                />
              </>
            )}
          </div>

          <div className="flex justify-end">
            <div className="ml-8  min-w-60">
              {/* <InfoTimeCardAdv
                title="Total Due"
                value={totalDue}
                prefix=""
                suffix="USD"
                color="primary"
                size="sm"
              /> */}
              <InfoCardNewAdv
                layout="option12"
                title="Total Due"
                // value={totalDue}
                value={calculateDiscountedTotal(tableAmountTotal,formData.discounts)}
                valueConfig={{className:"text-[24px]!", decimals:2}}
                suffixConfig={{className:"mt-1 justify-end! item-end! font-normal!"}}
                suffix="USD"
              />
            </div>
          </div>
        </div>

        {showFeilds() && (
          <>
            <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 ">
              <FormFieldSet
                type="textArea"
                title={"Billing Address"}
                placeholder="Enter Billing Address"
                value={formData.billingAddress}
                onChange={(value) => handleChange("billingAddress", value)}
                error={errors.billingAddress}
                rows={5}
                disabled={true}
              />
              <FormFieldSet
                type="textArea"
                title={"From Address"}
                placeholder="Enter From Address"
                value={formData.fromAddress}
                onChange={(value) => handleChange("fromAddress", value)}
                error={errors.fromAddress}
                rows={5}
                disabled={true}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6 max-w-7xl mt-4">
              <FormFieldSet
                // type="netTerm"
                type="select"
                title={"Net Terms"}
                placeholder="Select Net Terms"
                value={formData.netTerms}
                onChange={(value) => handleChange("netTerms", value)}
                error={errors.netTerms}
                options={netTermsOptions}
                // showButton
                showSearch
              />
              <FormFieldSet
                type="datepicker"
                title={"Invoice Date"}
                placeholder="Select Invoice Date"
                value={formData.invoiceDate}
                onChange={(value) => handleChange("invoiceDate", value)}
                error={errors.invoiceDate}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title={"Shipped Date"}
                placeholder="Select Shipped Date"
                value={formData.shippedDate}
                onChange={(value) => handleChange("shippedDate", value)}
                error={errors.shippedDate}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title={"Due Date"}
                placeholder="Select Due Date"
                value={formData.dueDate}
                onChange={(value) => handleChange("dueDate", value)}
                error={errors.dueDate}
                disabled={true}
                showDropdown={false}
              />
              {/* <FormFieldSet
                type="text"
                title={"Location"}
                placeholder="Enter Location"
                value={formData.location}
                onChange={(value) => handleChange("location", value)}
                error={errors.location}
              />
              <FormFieldSet
                type="text"
                title={"Class"}
                placeholder="Enter Class"
                value={formData.class}
                onChange={(value) => handleChange("class", value)}
                error={errors.class}
              /> */}
              <FormFieldSet
                type="text"
                title={"Invoice Number (Auto-Generated)"}
                placeholder="Enter Invoice Number"
                value={formData.invoiceNumber}
                onChange={(value) => handleChange("invoiceNumber", value)}
                error={errors.invoiceNumber}
                disabled={true}
              />
              <FormFieldSet
                type="text"
                title={"PO Number"}
                placeholder="Enter PO Number"
                value={formData.pONumber}
                onChange={(value) => handleChange("pONumber", value)}
                error={errors.pONumber}
              />
              <FormFieldSet
                type="checkbox"
                size={"md"}
                // noTitle={true}
                title=""
                options={[
                  {
                    label: "Include PO Attachment in Email",
                    value: true,
                  },
                ]}
                values={formData.includePOAttachment || []}
                onChange={(value) => handleChange("includePOAttachment", value)}
                multiple
                error={errors.includePOAttachment}
              />
            </div>
            <div className="mt-6">
              <p>Invoice Attachments</p>
              <Divider />
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-6 gap-y-6 mt-6">
                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">Contact Email(s)</span>
                    </ToolTip>
                  }
                  value={formData.contactEmail}
                  onChange={(value) => handleChange("contactEmail", value)}
                  error={errors.contactEmail}
                  multiple
                />
                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">CC Email(s)</span>
                    </ToolTip>
                  }
                  value={formData.ccEmail}
                  onChange={(value) => handleChange("ccEmail", value)}
                  error={errors.ccEmail}
                  multiple
                />

                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">BCC Email(s)</span>
                    </ToolTip>
                  }
                  placeholder="Enter Email"
                  value={formData.bccEmail}
                  onChange={(value) => handleChange("bccEmail", value)}
                  error={errors.bccEmail}
                  multiple
                />
                <FormFieldSet
                  type="text"
                  title={"Consultant Name"}
                  value={formData.consultantName}
                  onChange={(value) => handleChange("consultantName", value)}
                  error={errors.consultantName}
                />
              </div>
            </div>
          </>
        )}
        <div>
          <div className="flex justify-between mt-6 mb-1 items-end">
            <p>Service Summary</p>
            <div className="flex items-center gap-2">
            <Button
              color="orange"
              variant="icon"
              icon="refresh"
                onClick={() => {
                  setTableData([])
                  handleSelectTimeDate([])
              }}
            />
            <Button
              title="Add"
              color="black"
              icon="add"
              onClick={handleAddRow}
            />
            </div>
          </div>
          <Divider />
          <div className="mt-3">
            <TableAdv tableId={`invoices_addinvoices_placementinvoices`} rows={tableData} columns={columns} hideToolBar showSlNo />
          </div>
        </div>
        <div className="mt-4">
          <p>Notes & Total </p>
          <Divider />
        </div>
        <div className=" mt-2">
          <div className="flex flex-col  items-end gap-2">
            <div className="flex items-center gap-2">
              Subtotal:
              <div className="bg-black text-white pl-3 pr-2 py-2">
                {tableAmountTotal} USD
              </div>
            </div>
            <div className="flex flex-col gap-4 items-start w-full">
              {formData.discounts.map((discount, index) => (
                <div
                  key={discount.id}
                  className="grid grid-cols-[repeat(3,1fr)] items-start lg:grid-cols-[repeat(3,1fr)] xl:grid-cols-[repeat(4,1fr)_1.2fr] gap-6 mt-3 w-full"
                >
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      noTitle={true}
                      value={discount.name}
                      placeholder="Name"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "name", value)
                      }
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="select"
                      noTitle={true}
                      value={discount.type}
                      placeholder="Select"
                      onChange={(value) =>
                        handleDiscountTypeChange("type", value)
                      }
                      disabled={index !== 0}
                      options={[
                        { label: "Percentage", value: 1 },
                        { label: "value", value: 2 },
                      ]}
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="Discount"
                      noTitle={true}
                      value={discount.value}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "value", value)
                      }
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="comment"
                      noTitle={true}
                      value={discount.comment}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "comment", value)
                      }
                    />
                  </div>
                  <div className="mt-3 flex gap-2 items-center">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      onClick={handleAddDiscount}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      onClick={() => handleRemoveDiscount(discount.id)}
                    />
                    <div className="text-gray-600">
                      {/* {discount.value || 0} USD */}
                      {formatDiscountDisplay(discount, tableAmountTotal)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-end gap-2 mt-3">
              discount Total:
              <div>
                {calculateTotalDiscountInvoice(
                  formData?.discounts,
                  tableAmountTotal,
                )}
                USD
              </div>
            </div>
            {/* <div className="min-w-72 "> */}
            <div className="min-w-50 ">
              <Divider />
              <div className="flex justify-end ">
                <p>
                  Grand Total{" "}
                  <span className="ml-7">
                    {calculateDiscountedTotal(
                      tableAmountTotal,
                      formData.discounts,
                    )}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1 mt-4">
          <FormFieldSet
            type="textArea"
            placeholder="Enter Notes"
            title="Notes"
            value={formData.notes}
            onChange={(value) => handleChange("notes", value)}
            error={errors.notes}
          />
          <FormFieldSet
            type="text"
            title="Statement Memo"
            placeholder="Enter Statement Memo"
            value={formData.statementMemo}
            onChange={(value) => handleChange("statementMemo", value)}
            error={errors.statementMemo}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-2">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "Include Notes in invoice PDF",
                value: true,
              },
            ]}
            values={formData.includeNotesInInvoice || []}
            onChange={(value) => handleChange("includeNotesInInvoice", value)}
            multiple
            error={errors.includeNotesInInvoice}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-6 max-w-7xl ">
          <FormFieldSet
            type="datepickerRange"
            title=" Statement Memo Period From and To Date"
            placeholder="Select Statement Memo Period From and To Date"
            value={formData.statementMemoFromTo}
            onChange={(val) => handleChange("statementMemoFromTo", val)}
            error={errors.statementMemoFromTo}
            showDropdown={false}
          />
        </div>
        <div className="mt-4">
          <p>Additional Info </p>
          <Divider />
          <div className="border-[1px] border-neutrals-50 rounded p-3 min-h-[250px]">
            <FormFieldSet
              type="textArea"
              placeholder="Enter Additional Info"
              title=""
              value={formData.additionalInfo}
              onChange={(value) => handleChange("additionalInfo", value)}
              error={errors.additionalInfo}
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 my-6">
          <Button title={"Cancel"} variant="outlined" onClick={() => navigate("/invoices")} />
          {/* <Button title={"Save"} onClick={() => handleSave()} /> */}
          {/* <Button
            title={"Submit"}
            // onClick={() => setISMailSendModal(!isMailSendModal)}
            onClick={() => handleSubmitMail()}
          /> */}
          <Button
            title={"Proceed"}
            onClick={() => setIsProceedInvoiceOpen(true)}
          />
        </div>
        {formData.invoiceFrequency === "By Dates" && (
          <FromToDateModal
            isOpen={showfromToDate}
            onClose={() => setShowfromToDate(false)}
            value={formData.fromToDate}
            onChange={(val) => {
              handleChange("fromToDate", val);
            }}
            blockDates={allPreviousRanges || []}
            onSave={(val) => {
              if (val?.from && val?.to) {
                handleCallInvoiceApi(val);
              }
            }}
          />
        )}
      </div>
      {/* {(formData.invoiceFrequency === "By Dates" ||
        formData.invoiceFrequency === "By System Intervals") && ( */}
      {selectTimeSheetData.length > 0 && (
        <div className="flex-1 border-[1px] border-neutrals-50 rounded p-3 mt-2 w-full lg:w-[20%] h-full overflow-auto">
          <InvoiceSidebar
            data={selectTimeSheetData}
            selectedValues={selectedValues}
            handleSelectTimeDate={handleSelectTimeDate}
          />
        </div>
      )}
      {isMailSendModal && (
        <ResendModal
          open={isMailSendModal}
          onClose={() => {
            setISMailSendModal(!isMailSendModal);
            // navigate(-1);
            navigate("/invoices?invoices=all-invoices")
          }}
          toEmail={formData?.contactEmail}
          ccEmail={formData?.ccEmail}
          bccEmail={formData?.bccEmail}
          data={{
            orgLogo: loginUserData?.organizationId?.logo?.company || "",
            orgName: loginUserData?.organizationId?.name || "",
            invoiceNum: formData?.invoiceNumber || "",
            client: formData?.client?.label || "",
            dueDate: dayjs(formData?.dueDate).format("MM/DD/YYYY") || "",
            invoiceDate: dayjs(formData?.invoiceDate).format("MM/DD/YYYY") || "",
            // invoiceDate: dateFormator(formData?.invoiceDate),
            amount:
              formatCurrency(
                calculateDiscountedTotal(tableAmountTotal, formData?.discounts),
              ) || "",
            // invoiceUrl:
            //   import.meta.env.VITE_APP_ENV === "production"
            //     ? "https://tektree.kultworks.ai/invoices#all-invoices"
            //     : "https://staging.kultworks.ai/invoices#all-invoices"
              invoiceUrl:`${window.location.origin}/view/${loginUserData?.organizationId?.uiid}/${createdInvoiceId}`,  
          }}
          templateName="invoice_created"
          emailSubject={"Invoice Update..."}
          handleSave={handleSendMail}
          isMailSaving={isMailLoading}
        />
      )}

      {isProceedInvoiceOpen && (
        <ProceedInvoice
          isOpen={isProceedInvoiceOpen}
          data={formData}
          totalDue={totalDue}
          onClose={() => setIsProceedInvoiceOpen(false)}
          onSave={() => handleSave()}
          onSubmit={() => handleSubmit()}
          mappedRows={tableData}
          columns={columns}
          tableSubTotal={tableAmountTotal}
        />
      )}
      <Backdrop isOpen={loading} zIndex={60}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default PlacementInvoives;
